
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.542 17.125c-.435 0-.808-.155-1.118-.465a1.525 1.525 0 01-.465-1.118V5.25h-.792V3.667h3.958v-.792h4.75v.792h3.959V5.25h-.792v10.292c0 .435-.155.808-.465 1.118-.31.31-.683.465-1.118.465H5.542zM13.459 5.25H5.542v10.292h7.917V5.25zm-6.334 8.708H8.71V6.833H7.125v7.125zm3.167 0h1.583V6.833h-1.583v7.125z"}})])
          )
        }
      }
    